var _path, _rect, _rect2, _path2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportInstagramSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85547 7H4.86083M6.99833 7H7.00368M9.14118 7H9.14654",
    stroke: "white",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.41016,
    y: 2.74219,
    width: 7.90841,
    height: 1.86379,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.41016,
    y: 4.83008,
    width: 7.90841,
    height: 5.57948,
    fill: "#FFC121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72656 3.60213C2.72656 3.19224 2.87311 2.79914 3.13396 2.5093C3.39481 2.21947 3.7486 2.05664 4.1175 2.05664H10.6086C10.9775 2.05664 11.3313 2.21947 11.5921 2.5093C11.853 2.79914 11.9995 3.19224 11.9995 3.60213V4.63246C11.9995 4.76909 11.9507 4.90012 11.8637 4.99674C11.7768 5.09335 11.6588 5.14762 11.5359 5.14762V9.7841C11.5359 10.194 11.3893 10.5871 11.1285 10.8769C10.8676 11.1668 10.5138 11.3296 10.1449 11.3296H4.58115C4.21225 11.3296 3.85846 11.1668 3.59761 10.8769C3.33676 10.5871 3.19021 10.194 3.19021 9.7841V5.14762C3.06724 5.14762 2.94931 5.09335 2.86236 4.99674C2.77541 4.90012 2.72656 4.76909 2.72656 4.63246V3.60213ZM4.1175 5.14762V9.7841C4.1175 9.92073 4.16635 10.0518 4.2533 10.1484C4.34026 10.245 4.45819 10.2993 4.58115 10.2993H10.1449C10.2679 10.2993 10.3858 10.245 10.4728 10.1484C10.5597 10.0518 10.6086 9.92073 10.6086 9.7841V5.14762H4.1175ZM3.65386 4.1173V3.60213C3.65386 3.4655 3.70271 3.33447 3.78966 3.23786C3.87661 3.14124 3.99454 3.08697 4.1175 3.08697H10.6086C10.7315 3.08697 10.8495 3.14124 10.9364 3.23786C11.0234 3.33447 11.0722 3.4655 11.0722 3.60213V4.1173H3.65386ZM5.50845 7.20828C5.50845 7.07165 5.5573 6.94062 5.64425 6.844C5.7312 6.74739 5.84913 6.69312 5.97209 6.69312H8.75398C8.87695 6.69312 8.99488 6.74739 9.08183 6.844C9.16878 6.94062 9.21763 7.07165 9.21763 7.20828C9.21763 7.34491 9.16878 7.47594 9.08183 7.57256C8.99488 7.66917 8.87695 7.72344 8.75398 7.72344H5.97209C5.84913 7.72344 5.7312 7.66917 5.64425 7.57256C5.5573 7.47594 5.50845 7.34491 5.50845 7.20828Z",
    fill: "#FFC121"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.47852,
    y: 6.65234,
    width: 3.78072,
    height: 1.11837,
    rx: 0.482422,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportInstagramSave);
export default __webpack_public_path__ + "static/media/report-instagram-save.734d04cf121c809bba68bcfe1da45842.svg";
export { ForwardRef as ReactComponent };